import { Component, Mixins, Prop } from 'vue-property-decorator';
import addAwardsSuggestionMutation from '../../mutations/addAwardsSuggestion';
import awardsSuggestionsQuery from '../../queries/awardsSuggestions';
import { UtilMixin } from '../../UtilMixin';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import BooksCarousel from './booksCarousel.vue';

@Component({ components: { BooksCarousel, SingleMainContainer } })
export default class SuggestionsListAwardsAdder extends Mixins(UtilMixin) {
  @Prop() public suggestionsList!: any;

  public readonly query = awardsSuggestionsQuery;

  public readonly mutation = addAwardsSuggestionMutation;

  public mutationVariables(suggestionCandidate: any) {
    return {
      suggestionsListId: this.suggestionsList.id,
      publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
      awards: suggestionCandidate.source.awards,
    };
  }
}
